import script from "./ChatConfirmPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatConfirmPopup.vue?vue&type=script&setup=true&lang=ts"

import "./ChatConfirmPopup.vue?vue&type=style&index=0&id=12046d6a&lang=scss&scoped=true"

import exportComponent from "/var/www/briskly/brskl/products/business/app.prod.new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12046d6a"]])

export default __exports__